// extracted by mini-css-extract-plugin
module.exports = {"services":"ServicePage_services__bdFZ5"};